import { FC } from "react";

import ComponentScrollbar from "../ComponentScrollbar";
import Image, { ICONS } from "../Image";

import { ModalProps } from "./Modal.constants";
import {
  ModalOverlay,
  OuterContainer,
  ModalBody,
  ModalHeader,
  TitleContainer,
  CloseButtonArea,
  ModalInformationField,
  TitleText,
  ModalBodyContainer,
} from "./Modal.styles";

const Modal: FC<ModalProps> = ({
  title,
  maxWidth,
  children,
  IconSrc,
  setIsOpen,
  info,
  isClosable = true,
  boxShadow,
  onClose,
}) => {
  const handleClick = (): void => {
    onClose && onClose();

    setIsOpen && setIsOpen((prevState) => !prevState);
  };

  return (
    <>
      <OuterContainer boxShadow={boxShadow} maxWidth={maxWidth}>
        <ModalHeader isIcon={!!IconSrc?.length}>
          {title && (
            <TitleContainer>
              {IconSrc && (
                <Image
                  alt='Info Icon'
                  height='32px'
                  margin='3px 7px 0 0'
                  srcSet={IconSrc}
                  width='32px'
                />
              )}

              <TitleText>{title}</TitleText>
            </TitleContainer>
          )}

          {isClosable && (
            <CloseButtonArea isIcon={!!IconSrc?.length}>
              <Image
                alt='Close Icon'
                height='32px'
                onClick={handleClick}
                srcSet={ICONS.MODAL_CLOSE}
                width='32px'
                pointerIsOpen
              />
            </CloseButtonArea>
          )}
        </ModalHeader>

        <ModalBodyContainer>
          <ModalBody>
            {!!info?.length && (
              <ModalInformationField isIcon={!!IconSrc?.length}>
                {info}
              </ModalInformationField>
            )}

            {children}
          </ModalBody>
        </ModalBodyContainer>
      </OuterContainer>

      <ModalOverlay />
    </>
  );
};

export default Modal;
